module.exports = __webpack_public_path__ + "media/images/prev-75b80ba6816a44d4e4a952a339cdcf7b.svg";